import axios from "axios";
import { getCookie } from "../getcookie.js";
const apiUrl = process.env.REACT_APP_API_URL;
const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;

const header = {
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*", // Required for CORS support to work
  Authorization: getCookie("mawalog"),
};

export const getDeleteApi = async (deleteUrl) => {
  try {
    const response = await axios.delete(apiUrl + deleteUrl, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
    return err.response;
  } finally {
  }
};
export const getDeleteAdminApi = async (deleteUrl) => {
  try {
    const response = await axios.delete(adminApiUrl + deleteUrl, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
    return err.response;
  } finally {
  }
};

export const bulkDeleteApi = async (deleteUrl, ids) => {
  try {
    const response = await axios.delete(apiUrl + deleteUrl, {
      headers: header,
      data: { id: ids },
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
    return err.response;
  } finally {
  }
};

export const downloadExcelApi = async (apivalue) => {
  try {
    const response = await axios
      .get(apiUrl + apivalue, {
        headers: header,
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log("error...", error.response);
        return error.response;
      });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
    return err.response;
  } finally {
  }
};

export const uploadExcelApi = async (apivalue, base64String) => {
  try {
    const data = {
      file: base64String,
    };
    const headers = {
      "Content-Type": "application/json;",
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: getCookie("mawalog"),
    };
    const response = await axios
      .post(apiUrl + apivalue, data, { headers: headers })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
    return response;
  } catch (err) {
    console.error("Error fetching options:", err);
    return err.response;
    /*  setError("Failed to fetch options. Try again."); */
  } finally {
  }
};

export const downloadTemplateExcelApi = async (mater_type) => {
  try {
    const data = {
      type: mater_type,
    };
    const headers = {
      "Content-Type": "application/json;",
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: getCookie("mawalog"),
    };
    const response = await axios
      .post(apiUrl + "master_import/template_download", data, {
        headers: headers,
      })
      .then((response) => {
        console.log(response);
        return response;
      })
      .catch((error) => {
        return error.response;
      });
    return response;
  } catch (err) {
    console.error("Error fetching options:", err);
    return err.response;
    /*  setError("Failed to fetch options. Try again."); */
  } finally {
  }
};
